import ComponentBase from "../../../../public/component/component_base";
import UserDataManager from "../../../../../manager/user_manager";
import Utility from "../../../../../utility/utility";

const { ccclass, property } = cc._decorator;

@ccclass
export class GameChatCellView extends ComponentBase {

    @property(cc.Node)
    myNode: cc.Node = null;

    @property(cc.Sprite)
    myAvatar: cc.Sprite = null;

    @property(cc.Label)
    myName: cc.Label = null;

    @property( cc.Label)
    myContent: cc.Label = null;

    @property(cc.Node)
    myBg: cc.Node = null;

    @property(cc.Node)
    otherNode: cc.Node = null;

    @property(cc.Sprite)
    otherAvatar: cc.Sprite = null;

    @property(cc.Label)
    otherName: cc.Label = null;

    @property(cc.Label)
    otherContent: cc.Label = null;

    @property(cc.Node)
    otherBg: cc.Node = null;

    @property(cc.SpriteAtlas)
    atlas:cc.SpriteAtlas = null;

    @property([cc.Sprite])
    emotion:cc.Sprite[] = [];

    curLab: cc.Label | cc.RichText = null;

    private data: any;

    private userId: number

    private lineNum : number;

    setContent(isShow:boolean,isMe: boolean, content?: string) {
        this.myNode.active = isMe;
        this.otherNode.active = !isMe;
        this.myContent.node.active = isMe && isShow;
        this.otherContent.node.active = !isMe && isShow;
        if (isShow) {
            this.curLab = isMe ? this.myContent : this.otherContent;
            let txt = this.checkTxt(content);
            this.curLab.string = txt;
            this.lineNum = txt.split('\n').length;
        }
        
    }

    setData(data) {
        this.data = data.data;
    }

    getEmotionSize(){
       
    }

    setEmotion(isShow:boolean,isMe?:boolean,key?:string):cc.Size{

        this.emotion[0].node.active = isMe && isShow;
        this.emotion[1].node.active = !isMe && isShow;
        if (isShow) {
            let curEmotion = isMe?this.emotion[0]:this.emotion[1];
            curEmotion.spriteFrame = this.atlas.getSpriteFrame(key);
            return curEmotion.spriteFrame.getOriginalSize();
        }
        return cc.Size.ZERO
    }

    setUserId(userId : number){
        this.userId = userId;
    }

    setAvatar(isme: boolean, url: string,gender : number) {
        let self = this;
        let userId = self.userId;
        UserDataManager.getAvatarSprite(url, (spriteFrame) => {
        if (userId == self.userId) {       
            let icon = isme ? self.myAvatar : self.otherAvatar;
            icon.spriteFrame = spriteFrame;
        }
        },false,gender);
    }

    setName(isMe: boolean, name: string) {
        let nameText = isMe ? this.myName : this.otherName;
        nameText.string = Utility.filterPlayerName(name,10)
    }

    getHeight(): number {
        return 50.4 + (this.lineNum - 1)* this.curLab.lineHeight;
    }

    checkTxt(allContent: string) {

        let check = 18
        if (allContent.length < check) {
        return allContent;
        }

        let clampStr = allContent;

        let addtionStr : string[]= [];

        while(true){

        let clampInfo = Utility.strClampIndex(clampStr,check * 2,"");   

        let add : string = "";
        addtionStr.forEach(str=>{
            add += str
        })
        
        if (add + clampInfo.str == allContent) {
            
            if (!add) {          
            return allContent;
            }else{
            
            let result = "";
            addtionStr.forEach( (str,index)=>{
                result += str + "\n";                  
            })
            return result + clampInfo.str;
            }
        }        
        addtionStr.push(clampInfo.str);

        clampStr = clampStr.substring(clampInfo.index);
        } 
    }

    onClickAvatar() {
        if (this.userId) {
            Utility.playButtonSound();
        }
    }
}
